module.exports = __webpack_public_path__ + "static/media/EnvyCodeR.af58fbdc.ttf";